<template lang="pug">
.logout-modal
  b-modal(ref="modal" size="md" no-close-on-backdrop no-close-on-esc hide-header
    @ok="logout")
    div.default-modal-body
      div {{ message }}

    div(slot="modal-footer" slot-scope="{ ok, cancel }")
      button.btn.modal-ok-btn(type="button" @click="ok()") OK
      button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { Url } from "@/commons/constants/Url";
import { userStore, itemListFilterStore } from "@/store/store";

/**
 * ログアウトモーダル
 */
@Component
export default class LogoutModal extends Vue {
  /** メッセージ */
  @Prop({
    default: () => {
      return "ログアウトしますか？";
    }
  })
  message!: string;

  /**
   * モーダル表示
   */
  public show(): void {
    const modal: any = this.$refs.modal;
    if (modal) {
      modal.show();
    }

    return;
  }

  /**
   * OKボタン押下イベント
   */
  logout(): void {
    // ログアウトの実処理はstoreで行う
    userStore.logout();
    itemListFilterStore.initializeState();
    this.$router.push(Url.Root);

    return;
  }
}
</script>
